<!-- Shared template of app-localization-text-form-field and app-localization-text-area-form-field -->
<div class="localization-field">
    <div class="field-title" role="heading" aria-level="3" *ngIf="showTitle">
        {{ formElement.text }}
    </div>

    <div class="rows">
        <!-- First translation, always shown -->
        <div class="localization-row">
            <ng-container *ngTemplateOutlet="cultureSelect; context: { $implicit: rows[0], index: 0 }"></ng-container>
            <ng-container *ngTemplateOutlet="valueField; context: { $implicit: rows[0], index: 0 }"></ng-container>
        </div>

        <!-- Other translations -->
        <div class="additional-localizations" *ngIf="isExpanded">
            <ng-container *ngFor="let row of rows; let i = index">
                <div class="localization-row" *ngIf="i !== 0">
                    <ng-container *ngTemplateOutlet="cultureSelect; context: { $implicit: row, index: i }"></ng-container>
                    <ng-container *ngTemplateOutlet="valueField; context: { $implicit: row, index: i }"></ng-container>
                </div>
            </ng-container>

            <button
                *ngIf="canAddLocalization()"
                type="button"
                class="add-translation"
                appPreventDoubleClick (throttledClick)="addNewLocalization()"
            >
                <mat-icon class="material-icons-outlined" aria-hidden="true">add</mat-icon>
                {{ 'AddLocalization' | translate: {Default: "Add translation"} }}
            </button>
        </div>
    </div>

    <!-- Form directives in a template resolve their parent group where the template is declared, not where it's
         used, so the row's controls are passed in and bound with [formControl] -->
    <ng-template #cultureSelect let-row let-index="index">
        <mat-form-field appearance="fill" class="culture-field">
            <mat-select
                disableOptionCentering
                [formControl]="row?.get('culture')"
                panelClass="localization-culture-panel"
                [aria-label]="'Language' | translate: {Default: 'Language'}"
            >
                <mat-select-trigger>
                    <img *ngIf="flagSrc(row?.get('culture')?.value) as src; else noFlag" class="flag-icon" [src]="src" alt="">
                    <ng-template #noFlag><mat-icon class="material-icons-outlined no-flag" aria-hidden="true">language</mat-icon></ng-template>
                </mat-select-trigger>

                <mat-option></mat-option>
                <mat-option *ngFor="let culture of cultures" [value]="culture.id" [hidden]="isCultureUsedElsewhere(culture.id, index)">
                    <img class="flag-icon" [src]="flagSrc(culture.id)" alt="">
                    {{ culture.text }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </ng-template>

    <!-- The input must be declared in the same template as its mat-form-field, which finds it with a content query -->
    <ng-template #valueField let-row let-index="index">
        <mat-form-field appearance="fill" class="value-field">
            <mat-label>
                {{ formElement.text }}
                <mat-icon
                    *ngIf="index === 0 && formElement.tooltipText"
                    class="material-icons-outlined label-help"
                    [matTooltip]="formElement.tooltipText"
                    matTooltipPosition="above"
                    aria-hidden="true"
                >help_outline</mat-icon>
                <span class="sr-only" *ngIf="index === 0 && formElement.tooltipText">{{ formElement.tooltipText }}</span>
            </mat-label>

            <textarea
                *ngIf="multiline; else singleLine"
                matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="5"
                cdkAutosizeMaxRows="16"
                [formControl]="row?.get(formElement.localizationValueParam)"
                [attr.aria-disabled]="isFieldDisabled()"
                [attr.aria-readonly]="readOnly"
            ></textarea>
            <ng-template #singleLine>
                <input
                    matInput
                    [formControl]="row?.get(formElement.localizationValueParam)"
                    [attr.aria-disabled]="isFieldDisabled()"
                    [attr.aria-readonly]="readOnly"
                >
            </ng-template>

            <!-- The first row toggles the other translations; the others can be deleted -->
            <button
                *ngIf="index === 0"
                matSuffix
                mat-icon-button
                type="button"
                class="suffix-button translations-toggle"
                [class.active]="isExpanded"
                [attr.aria-expanded]="isExpanded"
                [attr.aria-label]="(isExpanded ? ('HideLocalizations' | translate: {Default: 'Hide translations'}) : ('ShowLocalizations' | translate: {Default: 'Show translations'})) + (rows.length > 1 ? ' (' + (rows.length - 1) + ')' : '')"
                [matTooltip]="isExpanded ? ('HideLocalizations' | translate: {Default: 'Hide translations'}) : ('ShowLocalizations' | translate: {Default: 'Show translations'})"
                appPreventDoubleClick (throttledClick)="toggleDiv()"
            >
                <mat-icon class="material-icons-outlined" aria-hidden="true">language</mat-icon>
                <span class="count" aria-hidden="true" *ngIf="rows.length > 1">{{ rows.length - 1 }}</span>
            </button>

            <button
                *ngIf="index !== 0 && editable"
                matSuffix
                mat-icon-button
                type="button"
                class="suffix-button delete-button"
                [matTooltip]="'Delete' | translate: {Default: 'Delete'}"
                [attr.aria-label]="('DeleteTranslation' | translate: {Default: 'Delete translation'}) + ': ' + formElement.text"
                appPreventDoubleClick (throttledClick)="deleteLocalization(index)"
            >
                <mat-icon class="material-icons-outlined" aria-hidden="true">delete</mat-icon>
            </button>
            <span class="sr-only" *ngIf="isFieldDisabled()">{{ getDisabledReadOnlyAnnouncement() }}</span>
        </mat-form-field>
    </ng-template>
</div>
